import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import { StyledContainer, StyledTable, StyledValue } from './FeesByRole.styled';

const FeesByRole: React.FC = () => {
  const { t } = useI18n('state-of-hiring');
  const { locale } = useRouter();

  const GRAPH_06_HIRING_FEES = [
    {
      role: locale === 'es' ? 'Desarrollo Backend' : 'Backend Developer',
      tier1: 3.7,
      tier2: 6.1,
      tier3: 7.4
    },
    {
      role: locale === 'es' ? 'Desarrollo Frontend' : 'Frontend Developer',
      tier1: 4.5,
      tier2: 5.8,
      tier3: 7.5
    },
    {
      role: locale === 'es' ? 'Desarrollo Full-Stack' : 'Full-Stack Developer',
      tier1: 0,
      tier2: 5.9,
      tier3: 6.8
    },
    {
      role: locale === 'es' ? 'Desarrollo Mobile' : 'Mobile Developer',
      tier1: 4.6,
      tier2: 6.7,
      tier3: 8.3
    },
    {
      role: locale === 'es' ? 'Infraestructura' : 'Infrastructure',
      tier1: 3.8,
      tier2: 6.0,
      tier3: 7.6
    },
    {
      role: locale === 'es' ? 'Datos' : 'Data',
      tier1: 0,
      tier2: 6.6,
      tier3: 8.7
    },
    {
      role: 'Product Manager',
      tier1: 5.0,
      tier2: 5.8,
      tier3: 7.9
    },
    {
      role: 'Tech Lead',
      tier1: 0,
      tier2: 0,
      tier3: 10.1
    },
    {
      role: 'Engineering Manager',
      tier1: 0,
      tier2: 0,
      tier3: 10.5
    }
  ];

  const getClassColor = (val: number): string => {
    if (val === 0) {
      return 'cell-color-1';
    }
    if (val > 0 && val <= 4) {
      return 'cell-color-2';
    }
    if (val > 4 && val <= 6) {
      return 'cell-color-3';
    }
    if (val > 6 && val <= 7) {
      return 'cell-color-4';
    }
    if (val > 7 && val <= 8) {
      return 'cell-color-5';
    }
    if (val > 8 && val <= 10) {
      return 'cell-color-6';
    }
    if (val > 10) {
      return 'cell-color-7';
    } else {
      return 'cell-color-1';
    }
  };

  return (
    <StyledContainer>
      <StyledTable>
        <thead>
          <tr>
            <th></th>
            <th>{t('state-of-hiring.fees.junior')}</th>
            <th>{t('state-of-hiring.fees.mid-level')}</th>
            <th>{t('state-of-hiring.fees.senior')}</th>
          </tr>
        </thead>
        <tbody>
          {GRAPH_06_HIRING_FEES.map((data, index) => (
            <tr key={index}>
              <th>{data.role}</th>
              <td>
                <StyledValue className={getClassColor(data.tier1)}>
                  {data.tier1 > 0 ? '€' + data.tier1 + 'K' : '-'}
                </StyledValue>
              </td>
              <td>
                <StyledValue className={getClassColor(data.tier2)}>
                  {data.tier2 > 0 ? '€' + data.tier2 + 'K' : '-'}
                </StyledValue>
              </td>
              <td>
                <StyledValue className={getClassColor(data.tier3)}>
                  {data.tier3 > 0 ? '€' + data.tier3 + 'K' : '-'}
                </StyledValue>
              </td>
            </tr>
          ))}
        </tbody>
      </StyledTable>
    </StyledContainer>
  );
};

export default FeesByRole;
